import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const Ticker = () => {
  const [stocks, setStocks] = useState([]);
  useEffect(() => {
    api.get("/stocks").then((r) => setStocks(r.data.stocks || [])).catch(() => {});
  }, []);
  if (!stocks.length) return null;
  const items = [...stocks, ...stocks]; // duplicate for seamless loop
  return (
    <div className="border-y border-white/10 bg-black/40 overflow-hidden" data-testid="ticker-marquee">
      <div className="animate-marquee inline-flex whitespace-nowrap py-3">
        {items.map((s, idx) => (
          <div key={idx} className="inline-flex items-center gap-3 px-6 border-r border-white/5">
            <span className="font-display font-bold text-xs text-white/60">{s.symbol}</span>
            <span className="font-mono text-sm">{s.currency === "IDR" ? s.price.toLocaleString("id-ID") : s.price.toFixed(2)}</span>
            <span className={`font-mono text-xs ${s.change_pct >= 0 ? "text-emerald-400" : "text-rose-400"}`}>
              {s.change_pct >= 0 ? "▲" : "▼"} {Math.abs(s.change_pct).toFixed(2)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
